import React from "react";

const ContactSales = () => {
  const styles = {
    page: {
      minHeight: "100vh",
      background: "#f6f7fb",
      display: "flex",
      justifyContent: "center",
      padding: "40px 16px",
      fontFamily: "Inter, sans-serif",
    },
    container: {
      background: "#ffffff",
      width: "100%",
      maxWidth: "480px",
      padding: "28px",
      borderRadius: "12px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    },
    logo: {
      height: "32px",
      marginBottom: "24px",
    },
    title: {
      margin: 0,
      fontSize: "28px",
      color: "#2d1b69",
    },
    subtitle: {
      color: "#6b6b6b",
      margin: "6px 0 24px",
    },
    label: {
      display: "flex",
      flexDirection: "column",
      fontSize: "14px",
      color: "#2d1b69",
      marginBottom: "16px",
    },
    input: {
      marginTop: "6px",
      padding: "12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid #dcdcdc",
      outline: "none",
    },
    select: {
      marginTop: "6px",
      padding: "12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid #dcdcdc",
      outline: "none",
      background: "#fff",
    },
    textarea: {
      marginTop: "6px",
      padding: "12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid #dcdcdc",
      height: "80px",
      resize: "none",
      outline: "none",
    },
    phoneRow: {
      display: "flex",
      gap: "8px",
      marginTop: "6px",
    },
    countryCode: {
      width: "90px",
      padding: "12px",
      borderRadius: "8px",
      border: "1px solid #dcdcdc",
      background: "#fff",
    },
    button: {
      marginTop: "16px",
      padding: "14px",
      background: "#6c4cf1",
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <img
          src="https://cashfree.com/assets/images/logo.svg"
          alt="Cashfree Payments"
          style={styles.logo}
        />

        <h1 style={styles.title}>Contact Sales</h1>
        <p style={styles.subtitle}>Tell us about yourself</p>

        <label style={styles.label}>
          Your Name*
          <input style={styles.input} placeholder="Rahul Sharma" />
        </label>

        <label style={styles.label}>
          Business Name*
          <input style={styles.input} placeholder="ABC Company Ltd." />
        </label>

        <label style={styles.label}>
          Registered business email ID*
          <input
            type="email"
            style={styles.input}
            placeholder="rahulsharma@cashfree.com"
          />
        </label>

        <label style={styles.label}>
          Mobile Number*
          <div style={styles.phoneRow}>
            <select style={styles.countryCode}>
              <option>🇮🇳 +91</option>
            </select>
            <input
              style={{ ...styles.input, flex: 1, marginTop: 0 }}
              placeholder="9876543210"
            />
          </div>
        </label>

        <label style={styles.label}>
          You want to use Cashfree Payments for*
          <select style={styles.select}>
            <option>Collecting Online Payment</option>
            <option>Payouts</option>
            <option>Subscriptions</option>
          </select>
        </label>

        <label style={styles.label}>
          Your Website or App Link*
          <input style={styles.input} placeholder="www.abc.com" />
        </label>

        <label style={styles.label}>
          GSTIN Number
          <input style={styles.input} placeholder="22ABCPD1234D1Z5" />
        </label>

        <label style={styles.label}>
          What is your business current annual revenue (in INR)*
          <select style={styles.select}>
            <option>Choose what describes you best</option>
            <option>Less than 10L</option>
            <option>10L – 1Cr</option>
            <option>1Cr – 10Cr</option>
            <option>Above 10Cr</option>
          </select>
        </label>

        <label style={styles.label}>
          Business Type*
          <select style={styles.select}>
            <option>Choose what describes you best</option>
            <option>Startup</option>
            <option>SME</option>
            <option>Enterprise</option>
          </select>
        </label>

        <label style={styles.label}>
          How would you use Cashfree Payments for your business*
          <textarea
            style={styles.textarea}
            placeholder="Briefly explain your use case"
          />
        </label>

        <button style={styles.button}>Submit</button>
      </div>
    </div>
  );
};

export default ContactSales;
